module.exports = __webpack_public_path__ + "img/tl-2-dub.2346df47.jpg";